import React from 'react';
import LimitRuleDetailSection from '../../../sections/AdminDashboard/Configuration/LimitRuleDetail';

const LimitRuleDetail = () => <LimitRuleDetailSection />;

export default LimitRuleDetail;
